var $16cf2bb6affc1ca9$exports = {};
$16cf2bb6affc1ca9$exports = {
  "pending": `pendiente`
};
export { $16cf2bb6affc1ca9$exports as default };